<ng-template #loading>
  <app-loading></app-loading>
</ng-template>

<div class="container" *ngIf=" product else loading">
  <div class="row">
    <div class="col-12">

      <div class="row">
        <div class="col-12 col-md-7 col-lg-6">
          <div class="category {{ product.category.slug }}">{{ product.category.name }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-7 col-lg-6">
          <div class="gallery">
            <app-gallery [images]="images" [category]="product.category.slug"></app-gallery>
          </div>
        </div>
        <div class="col-12 col-md-5 col-lg-6">

          <div class="d-flex flex-column justify-content-between" style="height: 100%;">
            <div class="baseInfo">
              <h1>
                <span class="type">{{ product.type.name }}</span>
                <span class="name">{{ product.name }}</span>
                <span class="type2">
                  {{ product.gama.name }}&nbsp;
                  <span>{{ product.capacity }}{{ isSame(product.capacity) ? ' ml' : '' }}</span>
                </span>
              </h1>
              <ul class="tags" *ngIf="product.tags.length > 0">
                <li *ngFor="let tag of product.tags">{{ tag.name }}</li>
              </ul>
            </div>

            <div>

              <a routerLink="/salon" class="btn btn-outline-dark btn-lg"><svg style="height: 20px; width: 20px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#map-marker-alt" x="0" y="0" /></svg> Znajdź salon</a>
              <br *ngIf="product.friser_link || product.hairstore_link">
              <button  *ngIf="product.friser_link || product.hairstore_link" class="btn btn--black btn-lg" (click)="buyProduct()">Kup teraz</button>

              <br>
            </div>

            <div class="mb-t wizaz" [ngClass]="{'borders': product.wizaz_id, 'minHeight': images.length > 1}">
              <app-wizaz-rating *ngIf="product.wizaz_id" [id]="product.wizaz_id"></app-wizaz-rating>
            </div>

          </div>
        </div>



        <div class="col-12 col-md-6 content">
          <h2 class="header-text">Opis produktu</h2>

          <div class="description" [innerHTML]="isJson(product.description) ? (wysiwigService.jsonToHtml(product.description) | safeHtml) :   (product.description | nl2br)"></div>
          <ng-container *ngIf="product.usage_description && isJson(product.usage_description) ? (wysiwigService.jsonToHtml(product.usage_description) | safeHtml) :   (product.usage_description | nl2br)">
            <h3 class="header-text">Sposób użycia</h3>
            <div class="description" [innerHTML]="isJson(product.usage_description) ? (wysiwigService.jsonToHtml(product.usage_description) | safeHtml) :   (product.usage_description | nl2br)"></div>
          </ng-container>

        </div>
        <div class="col-12 col-md-6 content">
          <div class="infobox" *ngIf="product.hair_type">
            <div class="image type"></div>
            <h3 class="header-text">Rodzaj Włosów</h3>
            {{ product.hair_type?.name }}
          </div>
          <div class="infobox" *ngIf="product.effects.length > 0">
            <div class="image effect"></div>
            <h3 class="header-text">Efekty</h3>
            <ng-container *ngFor="let effect of product.effects; let last = last;">
              {{ effect.name }} {{ !last ? ', ' : '' }}
            </ng-container>
          </div>


        </div>
        <ng-container *ngIf="product.component_description">
          <div class="col-12 col-md-6">
            <button class="componentsBtn" (click)="showComponents = !showComponents; showComposition(product.name)">

              <ng-template #componentInfo>
                Listy składników dla produktów naszej marki są regularnie aktualizowane. Zapoznaj się z listą składników
                na opakowaniu produktu, gdzie zawsze znajduje się najbardziej aktualna lista składników, aby upewnić
                się, że jest ona dla Ciebie odpowiednia.<br>(W przypadku produktów typu refill napełnianych w sklepie,
                najbardziej aktualną listę składników należy uzyskać w punkcie sprzedaży po uzupełnieniu w nim
                produktu).
              </ng-template>


              <h3 class="header-text">Skład produktu <sup [tooltip]="componentInfo">[i]</sup></h3>

              <svg *ngIf="!showComponents" style="height: 20px; width: 20px; margin-left: 15px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#chevron-down" x="0" y="0" /></svg>
              <svg *ngIf="showComponents" style="height: 20px; width: 20px; margin-left: 15px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#chevron-up" x="0" y="0" /></svg>

            </button>
          </div>
          <div class="col-12 mb-4">
            <!-- <div [hidden]="!showComponents" class="components" [innerHTML]="product.component_description | nl2br"></div> -->
            <div [hidden]="!showComponents" class="components" [innerHTML]="isJson(product.component_description) ? (wysiwigService.jsonToHtml(product.component_description) | safeHtml) :   (product.component_description | nl2br)"></div>
          </div>
        </ng-container>

        <div class="col-12 col-md-6">
          <app-wizaz-reviews *ngIf="product.wizaz_id" [id]="product.wizaz_id"></app-wizaz-reviews>
        </div>

      </div>

      <div *ngIf="product.similar.length > 0">
        <h2 class="mainHeader">Produkty komplementarne</h2>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let prod of product.similar">
            <app-product-box [product]="prod"></app-product-box>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="articles" *ngIf="product.articles?.length > 0">
    <h2>Jeśli zainteresował cię ten produkt, przeczytaj tez:</h2>

    <div class="row justify-content-center">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let article of product.articles">

        <a [routerLink]="['/artykuly', article.slug]">

          <div class="image" [style.backgroundImage]="'url(' + article.image + ')'"></div>
          <div class="name">
            {{ article.title }}
          </div>

        </a>
      </div>
    </div>

  </div>

</div>
